<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <!-- <v-btn
          text
          :href="`${mediaUrl} `"
          rounded
          color="primary"
          target="_blank"
        >
          <v-icon>mdi-download</v-icon>
          Download sample file
        </v-btn> -->
        <v-card-title>
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          Upload Old User Data
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col v-if="crud_old_user_datas.length == 0">
              <input
                type="file"
                id="file"
                name="file"
                ref="file"
                accept="application/ms-excel"
                multiple
                @input="handleFileUpload"
              />
              <section v-if="isUploading">
                <v-progress-linear
                  class="mt-5"
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
            </v-col>
            <v-col v-else>
              <v-btn
                color="success"
                :loading="isProcessing"
                :disabled="isProcessing"
                @click="processFile"
              >
                Upload file</v-btn
              >

              &nbsp;
              <v-btn color="error" @click="truncatePendingDocuments">
                Delete
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>
            <v-col
              class="text-end"
              v-if="crud_old_user_datas && crud_old_user_datas.length > 0"
            >
              <v-btn color="info" @click="fetchCalculatedPoints">
                Calculate Points
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <span style="color: red" v-show="isError">{{ error_msg }} </span>
          </v-row>
        </v-card-text>
      </v-card>
      <br />
      <v-card elevation="6" rounded="xxl">
        <v-card-text>
          <v-simple-table fixed-header>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" style="min-width: 130px">Date</th>
                  <th class="text-left" style="min-width: none">Name</th>
                  <th class="text-left" style="min-width: none">Phone No.</th>
                  <th class="text-left" style="min-width: none">Invoice No.</th>
                  <th class="text-left" style="min-width: none">Product</th>
                  <th class="text-left" style="min-width: none">HSN/SAC</th>
                  <th class="text-left" style="min-width: none">Quantity</th>
                  <th class="text-left" style="min-width: none">Unit</th>
                  <th class="text-left" style="min-width: 100px">
                    Price Per Unit
                  </th>
                  <th class="text-left" style="min-width: none">Discount</th>
                  <th class="text-left" style="min-width: none">GST</th>
                  <th class="text-left" style="min-width: none">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(crud_old_user_data, at) in crud_old_user_datas"
                  :key="`crud_old_user_data${at}`"
                >
                  <td>
                    {{ crud_old_user_data.date || "" }}
                  </td>
                  <td>
                    {{ crud_old_user_data.user_name || "" }}
                  </td>
                  <td>
                    {{ crud_old_user_data.phone || "" }}
                  </td>
                  <td>
                    {{ crud_old_user_data.invoice_no || "" }}
                  </td>
                  <td>
                    {{ crud_old_user_data.product || "" }}
                  </td>
                  <td>
                    {{ crud_old_user_data.hsn_sac || "" }}
                  </td>
                  <td>
                    {{ crud_old_user_data.quantity || "" }}
                  </td>
                  <td>
                    {{ crud_old_user_data.unit || "" }}
                  </td>
                  <td>
                    {{ crud_old_user_data.price_per_unit || "" }}
                  </td>
                  <td>
                    {{ crud_old_user_data.discount || "" }}
                  </td>
                  <td>
                    {{ crud_old_user_data.gst || "" }}
                  </td>
                  <td>
                    {{ crud_old_user_data.amount || "" }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
      <!-- Upload Success Dialog Box -->
      <v-dialog v-model="is_Uploaded" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-cloud-upload-outline
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>
                        The file has been uploaded successfully. Now you can
                        Preview the List & process accordingly.
                      </h3>
                      <br />
                      <v-btn color="success" @click="is_Uploaded = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Process Success Dialog Box -->
      <v-dialog v-model="is_Processed" width="800" max-width="90%">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col cols="12">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-row align="center">
                        <v-col cols="1">
                          <v-icon large style="color: green; font-size: 40px">
                            mdi-progress-download
                          </v-icon>
                        </v-col>
                        <v-col>
                          <h1 style="color: green">Processing Complete!</h1>
                        </v-col>
                      </v-row>
                      <br />

                      <!-- Display processing statistics -->
                      <div v-if="processResponse">
                        <h3>{{ processResponse.message }}</h3>
                        <br />

                        <!-- Statistics Cards -->
                        <v-row>
                          <v-col cols="3">
                            <v-card outlined class="pa-3 text-center">
                              <div class="text-h5 green--text">
                                {{ processResponse.uploaded_count || 0 }}
                              </div>
                              <div class="text-caption">Uploaded</div>
                            </v-card>
                          </v-col>
                          <v-col cols="3">
                            <v-card outlined class="pa-3 text-center">
                              <div class="text-h5 orange--text">
                                {{ processResponse.skipped_count || 0 }}
                              </div>
                              <div class="text-caption">Skipped</div>
                            </v-card>
                          </v-col>
                          <v-col cols="3">
                            <v-card outlined class="pa-3 text-center">
                              <div class="text-h5 red--text">
                                {{ processResponse.errors_count || 0 }}
                              </div>
                              <div class="text-caption">Errors</div>
                            </v-card>
                          </v-col>
                          <v-col cols="3">
                            <v-card outlined class="pa-3 text-center">
                              <div class="text-h5 blue--text">
                                {{
                                  (processResponse.uploaded_count || 0) +
                                  (processResponse.skipped_count || 0) +
                                  (processResponse.errors_count || 0)
                                }}
                              </div>
                              <div class="text-caption">Total Processed</div>
                            </v-card>
                          </v-col>
                        </v-row>

                        <br />

                        <!-- Expandable sections for details -->
                        <v-expansion-panels
                          v-if="
                            processResponse.uploaded &&
                            processResponse.uploaded.length > 0
                          "
                          class="mb-3"
                        >
                          <v-expansion-panel>
                            <v-expansion-panel-header>
                              <strong class="green--text"
                                >Successfully Uploaded ({{
                                  processResponse.uploaded_count
                                }})</strong
                              >
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-data-table
                                :headers="uploadedHeaders"
                                :items="processResponse.uploaded"
                                :items-per-page="10"
                                :footer-props="{
                                  'items-per-page-options': [
                                    5, 10, 25, 50, 100,
                                  ],
                                }"
                                class="elevation-1"
                                dense
                              >
                                <template v-slot:no-data>
                                  <div class="text-center pa-4">
                                    <v-icon size="64" color="grey lighten-2"
                                      >mdi-database-remove</v-icon
                                    >
                                    <p
                                      class="text-h6 grey--text text--lighten-1 mt-2"
                                    >
                                      No uploaded entries found
                                    </p>
                                    <p class="grey--text text--lighten-1">
                                      Upload some data to see results here
                                    </p>
                                  </div>
                                </template>
                              </v-data-table>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>

                        <v-expansion-panels
                          v-if="
                            processResponse.skipped &&
                            processResponse.skipped.length > 0
                          "
                          class="mb-3"
                        >
                          <v-expansion-panel>
                            <v-expansion-panel-header>
                              <strong class="orange--text"
                                >Skipped Entries ({{
                                  processResponse.skipped_count
                                }})</strong
                              >
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-data-table
                                :headers="skippedHeaders"
                                :items="processResponse.skipped"
                                :items-per-page="10"
                                :footer-props="{
                                  'items-per-page-options': [
                                    5, 10, 25, 50, 100,
                                  ],
                                }"
                                class="elevation-1"
                                dense
                              >
                                <template v-slot:no-data>
                                  <div class="text-center pa-4">
                                    <v-icon size="64" color="grey lighten-2"
                                      >mdi-database-remove</v-icon
                                    >
                                    <p
                                      class="text-h6 grey--text text--lighten-1 mt-2"
                                    >
                                      No skipped entries found
                                    </p>
                                    <p class="grey--text text--lighten-1">
                                      All data was processed successfully
                                    </p>
                                  </div>
                                </template>
                              </v-data-table>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>

                        <v-expansion-panels
                          v-if="
                            processResponse.errors &&
                            processResponse.errors.length > 0
                          "
                          class="mb-3"
                        >
                          <v-expansion-panel>
                            <v-expansion-panel-header>
                              <strong class="red--text">
                                Error Entries ({{
                                  processResponse.errors_count
                                }})
                              </strong>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-data-table
                                :headers="errorsHeaders"
                                :items="processResponse.errors"
                                :items-per-page="10"
                                :footer-props="{
                                  'items-per-page-options': [
                                    5, 10, 25, 50, 100,
                                  ],
                                }"
                                class="elevation-1"
                                dense
                              >
                                <template v-slot:no-data>
                                  <div class="text-center pa-4">
                                    <v-icon size="64" color="grey lighten-2"
                                      >mdi-database-remove</v-icon
                                    >
                                    <p
                                      class="text-h6 grey--text text--lighten-1 mt-2"
                                    >
                                      No errors found
                                    </p>
                                    <p class="grey--text text--lighten-1">
                                      All data was processed without errors
                                    </p>
                                  </div>
                                </template>
                              </v-data-table>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </div>

                      <!-- Fallback message if no response data -->
                      <div v-else>
                        <h3>
                          The file has been processed successfully. Now you can
                          see your users in User's Tab.
                        </h3>
                      </div>

                      <br />
                      <v-btn color="success" @click="is_Processed = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Truncate Success Dialog Box -->
      <v-dialog v-model="is_Truncated" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: red; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty-outline
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: red">Deleted!</h1>
                      <br />
                      <h3>
                        The file has been deleted successfully. Now you can
                        select a new file to upload.
                      </h3>
                      <br />
                      <v-btn color="success" @click="is_Truncated = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Dialog to show calculated points -->
      <v-dialog v-model="showCalculatedDialog" max-width="80%">
        <v-card rounded="xl">
          <v-card-title class="text-h6 font-weight-bold">
            Calculated Points by Phone
          </v-card-title>
          <v-card-text>
            <v-data-table
              v-model="selectedPhones"
              :headers="calculatedHeaders"
              :items="calculatedPoints"
              item-key="phone"
              show-select
              return-object
              :items-per-page="itemsPerPage"
              :footer-props="{
                'items-per-page-options': [
                  { text: '500', value: 500 },
                  { text: '1000', value: 1000 },
                  { text: '1500', value: 1500 },
                  { text: '2000', value: 2000 },
                  { text: 'ALL', value: -1 },
                ],
              }"
              class="elevation-1"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              v-if="selectedPhones.length > 0"
              color="error"
              @click="deleteSelectedPhones"
            >
              Delete All
            </v-btn>
            <v-btn color="primary" @click="showCalculatedDialog = false"
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
// import backbutton from "@/components/backbutton.vue";
export default {
  //   components: { backbutton },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Upload User Excel",
  },
  data() {
    return {
      crud_old_user_datas: [],
      isLoading: false,
      isUploading: false,
      is_Uploaded: false,
      isProcessing: false,
      is_Processed: false,
      is_Truncated: false,
      isError: false,
      error_msg: "",
      path: "",

      calculatedPoints: [],
      selectedPhones: [],
      itemsPerPage: 500,
      showCalculatedDialog: false,
      calculatedHeaders: [
        { text: "Phone", value: "phone" },
        { text: "Total Points", value: "total_points" },
        // { text: "Count", value: "count" },
        { text: "Status", value: "status" },
      ],

      // Process response data
      processResponse: null,

      // Headers for process response tables
      uploadedHeaders: [
        { text: "Row #", value: "row_number", sortable: true },
        { text: "Phone", value: "name", sortable: true },
        { text: "Message", value: "message", sortable: false },
      ],
      skippedHeaders: [
        { text: "Row #", value: "row_number", sortable: true },
        { text: "Phone", value: "name", sortable: true },
        { text: "Reason", value: "message", sortable: false },
      ],
      errorsHeaders: [
        { text: "Row #", value: "row_number", sortable: true },
        { text: "Phone", value: "name", sortable: true },
        { text: "Error", value: "message", sortable: false },
      ],
    };
  },
  watch: {
    selectedPhones(val) {
      console.log("Selected phones:", val);
    },
  },
  mounted() {
    this.getData();
    this.path = this.mediaUrl;
    console.log(this.path);
  },
  methods: {
    async getData(page = 1) {
      this.isLoading = true;
      try {
        await axios
          .get(`/crud_old_user_datas`)
          .then((crud_old_user_datas) => {
            this.crud_old_user_datas = crud_old_user_datas.data.data;
            this.count = crud_old_user_datas.data.count;
            this.serialNoStarting = (page - 1) * this.rowsPerPage;
            this.isLoading = false;
          })
          .catch(function (error) {
            console.log(error);
            window.location.href = "/auth/login";
          });
      } catch (error) {
        console.log(error);
      }
    },
    async handleFileUpload() {
      this.isUploading = true;
      this.isUploadingError = false;
      this.error_msg = "";
      this.users = this.$refs.file.files[0];
      let formData = new FormData();
      formData.append("users", this.users);
      this.changeValue = 100;
      await axios
        .post("crud_old_user_datas/upload_user", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.data) this.crud_old_user_datas = response.data.data;
          this.is_Uploaded = true;
        })
        .catch(() => {
          this.isError = true;
          this.error_msg =
            "Looks like system faced an error while uploading the File. Kindly check the file before uploading ...";
        });
      this.isUploading = false;
    },
    async processFile() {
      try {
        this.isProcessing = true;
        this.isError = false;
        this.error_msg = "";

        const response = await axios.get(`crud_old_user_datas/process_user`);

        // Store the response data for display in the dialog
        this.processResponse = response.data;

        this.isProcessing = false;
        this.is_Processed = true;

        // Clear the preview data
        await axios.get("crud_old_user_datas/truncate_users");
        this.crud_old_user_datas = [];
      } catch (error) {
        this.isProcessing = false;
        this.isError = true;

        // Get error message from response or use default
        const errorMessage =
          error.response?.data?.message ||
          error.response?.data?.error ||
          "Looks like system faced an error while processing the File. Kindly check the file before processing ...";

        this.error_msg = errorMessage;
        console.error("Process file error:", error);
      }
    },
    async truncatePendingDocuments() {
      try {
        await axios.get("crud_old_user_datas/truncate_users");
        this.is_Truncated = true;
        this.crud_old_user_datas = [];
      } catch (error) {
        console.log(error);
      }
    },
    async fetchCalculatedPoints() {
      try {
        const response = await axios.get(
          "crud_old_user_datas/calculate_points"
        );
        this.calculatedPoints = response.data.data;
        this.showCalculatedDialog = true;
      } catch (error) {
        console.error("Failed to fetch calculated points", error);
      }
    },
    getStatusColor(status) {
      switch (status.toLowerCase()) {
        case "high":
          return "green";
        case "medium":
          return "orange";
        case "low":
          return "red";
        default:
          return "grey";
      }
    },
    async deleteSelectedPhones() {
      let selectedPhoneNumbers = this.selectedPhones.map((data) => data.phone);
      try {
        const response = await axios.post(
          "/crud_old_user_datas/delete_by_phones",
          {
            phones: selectedPhoneNumbers,
          }
        );

        if (response.data.success && response.data.file_url) {
          // Trigger file download
          const link = document.createElement("a");
          link.href = response.data.file_url;
          link.setAttribute("download", "deleted_users.xlsx"); // Optional: specify filename
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
        // Refresh the table after deletion
        this.fetchCalculatedPoints();

        // Optional: Reset selection
        this.selectedPhones = [];
      } catch (error) {
        console.error("Error deleting selected phones", error);
      }
    },
  },
};
</script>
<style scoped>
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
td {
  min-width: 130px !important;
}
</style>
